import { motion } from 'framer-motion';
import { Users, BedDouble, Bath, ArrowUpRight } from 'lucide-react';
import { getImageUrl } from '../lib/utils-img';
import { Badge } from './ui/badge';
import CornerOrnament from './CornerOrnament';

export default function ListingCard({ listing, index = 0 }) {
  const handleClick = () => {
    if (listing.hostaway_booking_url) window.location.href = listing.hostaway_booking_url;
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }} transition={{ delay: index * 0.1, duration: 0.6 }}
      className="group relative bg-[#222225] rounded-xl overflow-hidden border border-white/[0.08] hover:border-gold/30 transition-all duration-700 cursor-pointer"
      onClick={handleClick} data-testid={`listing-card-${listing.id}`}
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img src={getImageUrl(listing.cover_image)} alt={listing.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#222225] via-transparent to-transparent" />
        {listing.badges?.length > 0 && (
          <div className="absolute top-4 left-4 flex gap-2">
            {listing.badges.map(b => (
              <Badge key={b} className="bg-gold/90 text-white text-[10px] uppercase tracking-[0.1em] border-0 px-3 py-1 font-semibold rounded-full">{b}</Badge>
            ))}
          </div>
        )}
        <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-3 group-hover:translate-y-0">
          <div className="w-11 h-11 bg-gold rounded-full flex items-center justify-center shadow-lg shadow-gold/30">
            <ArrowUpRight className="w-4 h-4 text-white" />
          </div>
        </div>
        {listing.location_name && (
          <div className="absolute bottom-4 left-4">
            <span className="text-[11px] text-white/70 font-medium">{listing.location_name}</span>
          </div>
        )}
      </div>

      <div className="p-5 sm:p-6 relative">
        <CornerOrnament size={14} offset="6px" />
        {listing.subtitle && <p className="text-[10px] uppercase tracking-[0.25em] text-gold font-bold mb-1.5">{listing.subtitle}</p>}
        <h3 className="font-heading text-lg text-white font-bold mb-2 group-hover:text-gold transition-colors duration-300">{listing.title}</h3>
        {listing.short_description && <p className="text-sm text-white/50 line-clamp-2 mb-5 leading-relaxed">{listing.short_description}</p>}

        <div className="flex items-center gap-0 border-t border-white/[0.08] pt-4 -mx-5 sm:-mx-6 px-5 sm:px-6">
          {listing.bedrooms > 0 && (
            <div className="flex items-center gap-2 flex-1 border-r border-white/[0.08] py-1">
              <BedDouble className="w-4 h-4 text-white/25" />
              <div><p className="text-[10px] text-white/35">Beds</p><p className="text-sm font-bold text-white">{listing.bedrooms}</p></div>
            </div>
          )}
          {listing.bathrooms > 0 && (
            <div className="flex items-center gap-2 flex-1 border-r border-white/[0.08] py-1 pl-4">
              <Bath className="w-4 h-4 text-white/25" />
              <div><p className="text-[10px] text-white/35">Baths</p><p className="text-sm font-bold text-white">{listing.bathrooms}</p></div>
            </div>
          )}
          {listing.guest_capacity > 0 && (
            <div className="flex items-center gap-2 flex-1 py-1 pl-4">
              <Users className="w-4 h-4 text-white/25" />
              <div><p className="text-[10px] text-white/35">Guests</p><p className="text-sm font-bold text-white">{listing.guest_capacity}</p></div>
            </div>
          )}
        </div>

        <div className="mt-5">
          <span className="block text-center py-3 bg-gold/10 text-gold text-[11px] uppercase tracking-[0.15em] font-semibold rounded-lg group-hover:bg-gold group-hover:text-white transition-all duration-300">
            {listing.cta_text || 'Book Now'}
          </span>
        </div>
      </div>
    </motion.div>
  );
}
